<template>
  <div class="buttonList" v-if="!hideButtons">
  <button class="contact-button" @click="openModal()" aria-label="Request a free roofing quote">Request A Free Quote</button>
  <button class="financing-button" @click="openFinancingLink()" aria-label="Apply for financing options">Apply for Financing</button>
  </div>
  <div id="modal" class="modal">
    <div class="modal-content"  data-scroll-index="7">
      <span class="close" @click="hardCloseModal()">&times;</span>
      

      <div class="contact-us-title">
        <h2>
          <span v-if="!isSubmitted">Contact Us Today For A Free Quote!</span>
          <span v-else-if="isSubmitted && !errorMessage">🎉 Thank You!</span>
          <span v-else-if="isSubmitted && errorMessage">We couldn't send your request</span>
        </h2>
        <p v-if="isSubmitted && !errorMessage" class="success-message">
          Your quote request has been received! We'll contact you within 24 hours.
          <br><br>
          Questions? Call us at <a href="#" @click.prevent="showPhoneModal = true">269-262-5055</a>
        </p>
        <p v-if="isSubmitted && errorMessage" class="error-fallback">
          We apologize for the inconvenience. Your information has been saved. Please contact us directly:
          <br><br>
          📞 <a href="#" @click.prevent="showPhoneModal = true">269-262-5055</a>
          <br>
          ✉️ <a href="mailto:homesroofingllc@gmail.com">homesroofingllc@gmail.com</a>
        </p>
      </div>


      <form v-if="!isSubmitted" id="form-data-collection" @submit.prevent="submitForm">
        <div class="form-groups">
          <div class="form-group">
            <label for="name"></label>
            <input type="text" id="name" name="name" v-model="name" required>
            <span class="floating-label">Name</span>
          </div>

          <div class="form-group">
            <label for="phone"></label>
            <input type="tel" id="phone" name="phone" v-model="phone" required>
            <span class="floating-label">Phone</span>
          </div>

          <div class="form-group">
            <label for="address"></label>
            <input type="text"  id="address" name="address" v-model="address" required>
            <span class="floating-label">Address</span>
          </div>

          <div class="form-group">
            <label for="city"></label>
            <input type="text"  id="city" name="city" v-model="city" required>
            <span class="floating-label">City</span>
          </div>

          <div class="form-group">
            <label for="zip-code"></label>
            <input type="text"  id="zip-code" name="zip-code" v-model="zipCode" required pattern="[0-9]{5}">
            <span class="floating-label">Zip</span>
          </div>

          <div class="form-group">
            <label for="email"></label>
            <input type="email" id="email" name="email" v-model="email" required>
            <span class="floating-label">Email</span>
          </div>
<!-- Maybe switch this to a radio button? -->
        </div>
        <div class="Selections">
          <h2 class="selector-label">How would you like to be contacted?</h2>
          <label for="preferences"></label>
          <select v-model="contactInfo" id="preferences" name="preferences">
            <option value="" disabled selected>Select one</option>
            <option value="Phone Call">Phone Call</option>
            <option value="Email">Email</option>
          </select>

          <h2 class="selector-label">Are you interested in financing?</h2>
          <label for="preferences"></label>
          <select v-model="financing" id="preferences" name="preferences">
            <option value="" disabled selected>Select one</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            <option value="Not Sure">I Would Like More Information</option>
          </select>

          <label for="services"></label>
          <h2 class="selector-label">What Services are you interested in?</h2>
          <select v-model="services" id="services" name="services" class="dropdown">
            <option value="" disabled selected>Select one</option>
            <option value="Roof Replacement">Roof Replacement</option>
            <option value="Roof Repair">Roof Repair</option>
            <option value="Siding">Siding</option>
            <option value="Fascia & Soffit">Fascia & Soffit</option>
            <option value="Inspections">Inspections</option>
            <option value="Gutter Replacement">Gutter Replacement</option>
            <option value="Winter Services">Winter Services</option>

          </select>
          
      </div>
      <button type="submit" class="Request">Request Quote</button>
      
      </form>

    <div class="bottom-content">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 d-flex align-items-center">
                    <div class="contact-info">

                        <h2 class="contact-title">Prefer to Contact Us Directly?</h2>
                        <ul class="contact-info">
                            <li>
                              <div class="info-left">
                                  <i class="fas fa-mobile-alt"></i>
                              </div>
                              <div class="info-right">

                                <p>Phone: <a href="#" @click.prevent="showPhoneModal = true">269-262-5055</a></p>
                              </div>
                            </li>
                            <li>
                              <div class="info-left">
                                  <i class="fas fa-at"></i>
                              </div>
                              <div class="info-right">
                                <p>Email: <a href="mailto:Homesroofingco@Gmail.com">Homesroofingco@Gmail.com</a></p>
                              </div>
                            </li>
                            <li>
                            </li>
                        </ul>
                    </div>
                </div>
          </div>
        </div>  
      </div>  
    </div>
  </div>
  <PhoneModal v-if="showPhoneModal" @close="showPhoneModal = false" />
</template>

<script>

import emailjs from 'emailjs-com';
import PhoneModal from '@/components/PhoneModal.vue';

/* eslint-disable */
export default {
  name: 'ContactForm',
  components: { PhoneModal },
  props: {
    hideButtons: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      errorMessage: '',
      name: '',
      phone: '',
      address: '',
      city: '',
      zipCode: '',
      email: '',
      contactInfo: '',
      financing: '',
      services: '',
      message: '',
      modalOpen: false,
      isSubmitted: false,
      showPhoneModal: false,
    }
  },
  methods: {
    openFinancingLink() {
      window.open("https://www.enhancify.com/homes-roofing", "_blank", "noopener");
    },
    openModal() {
      document.getElementById('modal').style.display = 'flex';
      this.modalOpen = true
      document.body.classList.add('modal-open')
    },
    hardCloseModal() {
      document.getElementById('modal').style.display = 'none';
      this.modalOpen = false
      document.body.classList.remove('modal-open')
    },
    closeModal() {
      this.isSubmitted = true;
      document.body.classList.remove('modal-open')
    },
    submitForm() {
      const params = {
        name: this.name,
        phone: this.phone,
        address: this.address,
        city: this.city,
        zipCode: this.zipCode,
        email: this.email,
        contactInfo: this.contactInfo,
        financing: this.financing,
        services: this.services,
        message: this.message,
        submittedAt: new Date().toISOString()
      }
      
      emailjs.send('service_l441b6k', 'template_9p9zsw9', params, 'LpW2_wi0xAADm0_7n')
        .then(response => {
          console.log('SUCCESS!', response.status, response.text);
          this.errorMessage = '';
          this.isSubmitted = true;
          document.getElementById('form-data-collection').reset();
          document.body.classList.remove('modal-open');
        })
        .catch(error => {
          console.log('FAILED...', error);
          
          // Save to localStorage as backup
          this.saveFailedSubmission(params);
          
          // Show error to user
          this.errorMessage = true;
          this.isSubmitted = true;
          document.body.classList.remove('modal-open');
        });
    },
    
    saveFailedSubmission(params) {
      // Get existing failed submissions or initialize empty array
      const existingSubmissions = JSON.parse(localStorage.getItem('failedQuoteSubmissions') || '[]');
      
      // Add this submission
      existingSubmissions.push({
        ...params,
        failedAt: new Date().toISOString()
      });
      
      // Save back to localStorage
      localStorage.setItem('failedQuoteSubmissions', JSON.stringify(existingSubmissions));
      
      // Log for debugging
      console.warn('Form submission saved to localStorage. Total failed submissions:', existingSubmissions.length);
    },
    
    // Call this from browser console to see failed submissions: 
    // JSON.parse(localStorage.getItem('failedQuoteSubmissions'))
    getFailedSubmissions() {
      return JSON.parse(localStorage.getItem('failedQuoteSubmissions') || '[]');
    },
    
    clearFailedSubmissions() {
      localStorage.removeItem('failedQuoteSubmissions');
      console.log('Failed submissions cleared');
    }
  }
}
</script>

<style scoped>
.buttonList {
  display: flex;
  flex-direction: row;
}

/* Stack CTA buttons and make them near full-width on tablet and smaller */
@media (max-width: 1080px) {
  .buttonList {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    width: 92vw;
    max-width: 560px;
    margin: 0 auto;
  }
  
  .contact-button,
  .financing-button {
    width: 100%;
    min-width: 0;
    margin-right: 0;
    padding: 16px 18px;
  }
}

/* Contact button */
.contact-button {
  background-color: #8d0808; /* Use your brand color */
  color: white;
  padding: 15px 30px; /* Increase padding */
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease; /* Add a transform transition */
  font-size: 1.2em; /* Increase font size */
  z-index: 2;
  margin-right: 10px;
  }

  @media (max-width: 500px){
    .contact-button {
      font-size: .9em;
    }
   }

  .financing-button{
    background-color: #6FACF9; /* Use your brand color */
  color: white;
  padding: 15px 30px; /* Increase padding */
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease; /* Add a transform transition */
  font-size: 1.2em; /* Increase font size */
  z-index: 2;
  margin-right: 10px;
  }
  @media (max-width: 500px){
    .financing-button {
      font-size: .9em;
    }
   }

  .financing-button:hover {
  background-color: #6FACF9;
  transform: scale(1.05);
}

.financing-button:active {
  transform: translateY(2px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
}


.contact-button:hover {
  background-color: #6FACF9;
  transform: scale(1.05);
}

.contact-button:active {
  transform: translateY(2px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
}

/* Modal */
.modal {
  display: none;
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 24px 16px;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  z-index: 1000;
}

.modal-open {
  overflow: hidden;

  @media screen and (max-height: 768px) {
    overflow: scroll;
  }
}

.modal-content {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: 500px;
  max-height: calc(100vh - 12px);
  overflow-y: auto;
  background: linear-gradient(135deg, #e8eaf6 0%, #c5cae9 100%);
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.6);
}

/* Form */
#form-data-collection {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  align-items: center;
  background: linear-gradient(135deg, #d0d4e4 0%, #b8bfd9 100%);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-top: 0;
}

.form-groups {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-bottom: 15px;
  padding: 0 8px;
}

.form-group {
  position: relative;
  display: flex;
  flex: 1 1 calc(50% - 12px);
  min-width: 150px;
}

.form-groups input {
  height: 2.3rem;
  width: 100%;
  border: 2px solid #b0b8d4;
  border-radius: 5px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  background-color: white;
}

.form-groups input:focus {
  height: 2.3rem;
  border: 2px solid #6FACF9;
  box-shadow: 0 0 8px rgba(111, 172, 249, 0.3);
  outline: none;
}

.Selections {
  margin-bottom: 12px;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  width: calc(100% - 16px);
}

#preferences, #services {
  height: 2.3rem;
  border: 2px solid #b0b8d4;
  width: 100%;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 0 10px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  background-color: white;
}

#preferences:focus, #services:focus {
  border: 2px solid #6FACF9;
  box-shadow: 0 0 8px rgba(111, 172, 249, 0.3);
  outline: none;
}

.form-group input {
  padding: 8px 8px 3px 8px;
  border-radius: 5px;
  background-color: white;
}

.form-group input:focus ~ .floating-label,
.form-group input:not(:focus):valid ~ .floating-label {
  font-size: 11px;
  opacity: 1;
  color: #6FACF9;
  transform: translate(-8px, -22px);
  font-weight: 600;
}

.form-group .floating-label {
  position: absolute;
  color: #666;
  pointer-events: none;
  left: 12px;
  top: 12px;
  transition: 0.2s ease all;
  background-color: white;
  padding: 0 4px;
}

/* Close button */
.close {
  position: absolute;
  color: #950d0f;
  top: 0px;
  right: 10px;
  font-size: 34px;
  font-weight: bold;
  cursor: pointer;
}

/* Request button */
.Request {
  width: calc(100% - 16px);
  height: 45px;
  background: linear-gradient(135deg, #8d0808 0%, #b91010 100%);
  color: white;
  display: flex;
  font-size: 18px;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  margin: 8px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.Request:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #a01010 0%, #d01515 100%);
}

.Request:active {
  transform: translateY(0px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Selector label */
.selector-label {
  text-wrap: balance;
  font-size: 16px;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  color: #2c3e50;
  margin-bottom: 6px;
  margin-top: 5px;
  font-weight: 600;
}

/* Contact info */
.bottom-content {
  padding: 8px 8px 6px;
  color: white;
  background: linear-gradient(135deg, #002655 0%, #4a7ba7 100%);
  border-bottom-left-radius: 17px;
  border-bottom-right-radius: 17px;
  font-family: 'Roboto', sans-serif;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
}
.contact-us-title{
  text-align: center;
  color: #2c3e50;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  margin-top: 12px;
  margin-bottom: 2px;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
}

.error-fallback {
  background-color: #2c3e50;
  border: 2px solid #8d0808;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 8px 10px;
  font-size: 16px;
  line-height: 1.6;
  color: white;
}

.error-fallback a {
  color: #f1c40f;
  font-weight: bold;
  text-decoration: none;
}

.error-fallback a:hover {
  text-decoration: underline;
}

.success-message {
  background-color: #002655;
  border: 2px solid #f1c40f;
  border-radius: 8px;
  padding: 10px 12px;
  margin: 8px 10px 16px;
  font-size: 16px;
  line-height: 1.6;
  color: white;
}

.success-message a {
  color: #f1c40f;
  font-weight: bold;
  text-decoration: none;
}

.success-message a:hover {
  text-decoration: underline;
}

.contact-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 0px;
  list-style-type: none;
}

.contact-info a {
  color: #f1c40f;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-info a:hover {
  color: white;
  text-decoration: underline;
}

.contact-info p {
  margin-top: 0px;
  font-size: 16px;
}

.contact-info h2 {
  margin: unset;
}

.contact-title {
  margin: 0 0 10px 0;
  font-size: 18px;
  color: white;
  text-align: center;
}

/* Mobile responsiveness */
@media (max-width: 500px) {
  .modal-content {
    max-width: 95vw;
    max-height: calc(100vh - 8px);
    border-radius: 15px;
  }
  
  .form-group {
    flex: 1 1 100%;
  }
  
  .form-groups {
    padding: 0 6px;
  }
  
  .Selections {
    padding: 0 6px;
  }
  
  .contact-us-title {
    font-size: 17px;
    margin-top: 12px;
  }
  
  .selector-label {
    font-size: 16px;
  }
  
  .Request {
    font-size: 17px;
    margin: 8px 6px;
  }
}

/* Option */

</style>